import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Avatar, useTheme } from '@mui/material';
import { fonts } from '@theme/fontsCustomer';
import { ErrorIcon } from '@icons/ErrorIcon';

interface Props {
  isNext?: boolean;
}

export const EmptyPayment = ({ isNext = false }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Container>
      <Avatar sx={{ backgroundColor: theme.colors['bg-primary-lighter'], width: '36px', height: '36px' }}>
        <ErrorIcon color={theme.colors['ic-primary-light']} />
      </Avatar>

      <span>{isNext ? t('Acc_Main_33') : t('Acc_Main_32')}</span>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  ${fonts.Body2};
  color: ${props => props.theme.colors['text-gray-sub-dark']};
  height: 100%;
  border: 1px solid ${props => props.theme.colors['border-gray-lighter']};
  border-radius: 7px;
  box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.02);
`;
